import dayjs from 'dayjs';

// 리뷰 작성 가능 기간을 배송 주문 수정일로부터 3개월로 제한합니다.
export const REVIEW_WRITE_PERIOD_MONTHS = 3;

/**
 * 배송 주문의 마지막 수정일을 기준으로 리뷰 작성 가능 기간을 확인합니다.
 * --
 */
export const isWithinReviewWritePeriod = (updatedAt) => {
  const timestamp = Number(updatedAt);

  if (!Number.isFinite(timestamp) || timestamp <= 0) return false;

  // 초와 밀리초 형식의 타임스탬프를 모두 처리합니다.
  const updatedDate =
    timestamp > 9999999999 ? dayjs(timestamp) : dayjs.unix(timestamp);

  return !dayjs().isAfter(updatedDate.add(REVIEW_WRITE_PERIOD_MONTHS, 'month'));
};
